import axios, { AxiosRequestConfig } from 'axios';
import NotificationService from 'services/notification';
import cookie from 'react-cookies';

export const URL_API_DEV = 'https://aserta.mrmilu.com/api/v1';
export const URL_API_PROD = 'https://scoring.aserta.com.es/api/v1';
export const URL_API_LOCAL = 'http://192.168.1.58:3000/api/v1';

class HttpService {

  static getHost() {
    switch (process.env.ASERTA_FRONT_ENV) {
      case 'staging':
        return URL_API_DEV
      case 'production':
        return URL_API_PROD
      default:
        return URL_API_LOCAL
    }
  }

  static instance = axios.create({
    baseURL: HttpService.getHost(),
    withCredentials: true
  });

  static getFile(path, filters) {
    return new Promise((resolve, reject) => {
      axios({
        withCredentials: true,
        url: this.getHost() + path,
        method: 'GET',
        responseType: 'blob',
        params: filters,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch(function (error) {
        if (error.response) {
          NotificationService.error(error.response.data);
          reject(error.response.data);
        }
        else {
          NotificationService.error(error.message);
          reject(error);
        }
      });
    })
  }

  static get(path, filters) {
    return new Promise((resolve, reject) => {
      this.instance.get(path, {params: filters})
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          if (error.response) {
            NotificationService.error(error.response.data);
            reject(error.response.data);
          }
          else {
            NotificationService.error(error.message);
            reject(error);
          }
        });
    });
  }

  static post(path, filters) {
    return new Promise((resolve, reject) => {
      this.instance.post(path, filters)
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          if (error.response) {
            reject(error.response.data);
            NotificationService.error(error.response.data);
          }
          else {
            reject(error);
            NotificationService.error(error.message);
          }
        });
    });
  }

  static patch(path, data) {
    return new Promise((resolve, reject) => {
      this.instance.patch(path, data)
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          if (error.response) {
            reject(error.response.data);
            NotificationService.error(error.response.data);
          }
          else {
            reject(error);
            NotificationService.error(error.message);
          }
        });
    });
  }

  static upload(path, data) {
    return new Promise((resolve, reject) => {
      var formData = new FormData();
      for(var key in data) {
        formData.append(key, data[key]);
      }
      var config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        },
        headers: {
            'content-type': 'multipart/form-data'
        }
      };
      this.instance.post(path, formData, config)
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          if (error.response) {
            reject(error.response.data);
            NotificationService.error(error.response.data);
          }
          else {
            reject(error);
            NotificationService.error(error.message);
          }
        });
    });
  }

  static setHeader(key, value) {
    this.instance.defaults.headers.common[key] = value;
  }

  static removeHeader(key) {
    delete this.instance.defaults.headers.common[key];
  }

}

HttpService.instance.interceptors.request.use(
  (config) => {
    const token = cookie.load('csrftoken');
    if (token) config.headers['X-CSRFToken'] = token;
    return config;
  }
);

export default HttpService;



// WEBPACK FOOTER //
// ./services/http.js